import { styled } from 'styled-components';
import { Typography } from '@altibox/design-system-component-lib';

import { LargeContainer } from 'src/components/container';
import { Image } from 'src/components/image';
import { breakpointLargeTablet } from 'src/styles/breakpoints';
import { colorNeutral, colorPrimary500, colorSecondary900 } from 'src/styles/colors';
import { focus } from 'src/styles/mixins';
import { spacing1 } from 'src/styles/spacing';

export const StyledHeader = styled.header`
  background: ${colorPrimary500};
  position: relative;
`;

export const StyledHeaderContainer = styled(LargeContainer)`
  display: flex;
  align-items: center;
  min-height: 72px;
  justify-content: right;
`;

export const StyledLinkText = styled(Typography)`
  color: ${colorNeutral};
  font-weight: bold;
  margin-left: ${spacing1};
  height: 24px;
  line-height: 24px;
  font-size: 18px;
  box-sizing: border-box;

  &:hover {
    color: ${colorNeutral};
    border-bottom: 1px solid ${colorNeutral};
  }
`;

export const StyledLink = styled.a`
  text-decoration: none;
  display: none;

  ${focus};

  @media (min-width: ${breakpointLargeTablet}) {
    display: flex;
  }
`;

export const StyledLogo = styled(Image)`
  width: 96px;
  position: absolute;
  inset: 0;
  margin: auto;

  @media (min-width: ${breakpointLargeTablet}) {
    width: 253px;
  }
`;

// FIXME add primary font-family

export const StyledLogoutButton = styled.button`
  color: ${colorNeutral};
  font-size: 16px;
  height: 48px;
  font-weight: bold;
  background: ${colorPrimary500};
  border-radius: 4px;
  border: 0;
  margin-left: auto;

  &:hover {
    background: ${colorNeutral};
    color: ${colorSecondary900};
    cursor: pointer;
  }

  ${focus};

  @media (min-width: ${breakpointLargeTablet}) {
    font-size: 18px;
    width: 118px;
    border: 2px solid rgb(255 255 255 / 50%);
  }
`;
